import { render, staticRenderFns } from "./RL7000.vue?vue&type=template&id=13c589c9&scoped=true"
import script from "./RL7000.vue?vue&type=script&lang=js"
export * from "./RL7000.vue?vue&type=script&lang=js"
import style0 from "./RL7000.vue?vue&type=style&index=0&id=13c589c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c589c9",
  null
  
)

export default component.exports